import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

const settigsSearchSchema = z.object({
  privacy: z.string().optional(),
  ['auto-topup-result']: z.literal('success').or(z.literal('error')).optional(),
});

export const Route = createFileRoute(
  '/_auth/_layout_with_full_navigation/settings',
)({
  validateSearch: zodValidator(settigsSearchSchema),
});
